import { IBrandsBodyFetchState, IInitialBrandsState } from 'interfaces/brands.interface';
import * as BrandsTypes from './brands.types';
import * as api from 'api/endpoints/myBrands/myBrands.api';
import { ITranslate } from 'interfaces/general.interface';
import { brandsError } from 'utils/errorCodes';
import { notificationErr } from 'views/components/notification';
import { TbrandsDispatchReducer } from './brands.reducer';

export async function getPaginationBrandsAction({
  dispatch,
  bodyFetch,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TbrandsDispatchReducer>;
  bodyFetch: IBrandsBodyFetchState;
  token: string;
  translate: ITranslate;
}): Promise<boolean> {
  try {
    const brandsFetch = await api.getBrandsAPI({ body: bodyFetch, token });
    if (brandsFetch.response.status === 404) {
      dispatch({ type: BrandsTypes.SET_THERE_ARE_MORE_BRANDS, payload: false });
      dispatch({ type: BrandsTypes.GET_PAGINATION_BRANDS, payload: [] });
      return false;
    }
    if (brandsFetch.response.status === 200) {
      for (const [index, brand] of brandsFetch.data.entries()) {
        brand.logo = `${brand.logo}?t=${new Date().getTime()}`;
        brandsFetch.data[index] = brand;
      }
      dispatch({
        type: BrandsTypes.GET_PAGINATION_BRANDS,
        payload: brandsFetch.data,
      });
      return true;
    }
    if (brandsFetch.response.status !== 503) {
      notificationErr(brandsError.getPaginationBrands_002, translate);
    }
    return false;
  } catch (err) {
    notificationErr(brandsError.getPaginationBrands_001, translate);
    return false;
  } finally {
    dispatch({ type: BrandsTypes.SET_IS_LOADING_GET_PAGINATION_BRANDS, payload: false });
  }
}

export async function getAllBrandsAction({
  dispatch,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TbrandsDispatchReducer>;
  token: string;
  translate: ITranslate;
}): Promise<boolean> {
  try {
    const brandsFetch = await api.getBrandsAPI({
      body: {
        search: '',
        index: 0,
        limit: 10000,
      },
      token,
    });
    if (brandsFetch.response.status === 404) return false;
    if (brandsFetch.response.status === 200) {
      for (const [index, brand] of brandsFetch.data.entries()) {
        brand.logo = `${brand.logo}?t=${new Date().getTime()}`;
        brandsFetch.data[index] = brand;
      }
      dispatch({
        type: BrandsTypes.GET_ALL_BRANDS,
        payload: brandsFetch.data,
      });
      return true;
    }
    if (brandsFetch.response.status !== 503) {
      notificationErr(brandsError.getAllBrands_002, translate);
    }
    return false;
  } catch (err) {
    notificationErr(brandsError.getAllBrands_001, translate);
    return false;
  } finally {
    dispatch({ type: BrandsTypes.SET_IS_LOADING_GET_ALL_BRANDS, payload: false });
  }
}

export async function addMoreBrandsAction({
  dispatch,
  state,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TbrandsDispatchReducer>;
  state: IInitialBrandsState;
  token: string;
  translate: ITranslate;
}): Promise<boolean> {
  dispatch({ type: BrandsTypes.SET_IS_LOADING_GET_PAGINATION_BRANDS, payload: true });
  try {
    const brandsFetch = await api.getBrandsAPI({ body: state.bodyFetch, token });
    if (brandsFetch.response.status === 404) {
      dispatch({
        type: BrandsTypes.SET_THERE_ARE_MORE_BRANDS,
        payload: false,
      });
      return false;
    }
    if (brandsFetch.response.status === 200) {
      for (const [index, brand] of brandsFetch.data.entries()) {
        brand.logo = `${brand.logo}?t=${new Date().getTime()}`;
        brandsFetch.data[index] = brand;
      }

      dispatch({
        type: BrandsTypes.ADD_MORE_BRANDS,
        payload: brandsFetch.data,
      });
      return true;
    }
    notificationErr(brandsError.addMoreBrands_002, translate);
    return false;
  } catch (err) {
    notificationErr(brandsError.addMoreBrands_001, translate);
    return false;
  } finally {
    dispatch({ type: BrandsTypes.SET_IS_LOADING_GET_PAGINATION_BRANDS, payload: false });
  }
}

export async function setBodySearchGetBrandsAction({
  dispatch,
  query,
  bodyFetch,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TbrandsDispatchReducer>;
  query: string | null;
  bodyFetch: IBrandsBodyFetchState;
  token: string;
  translate: ITranslate;
}): Promise<boolean> {
  if (query === null) {
    dispatch({ type: BrandsTypes.SET_BODY_SEARCH, payload: query });
    return true;
  }
  bodyFetch.index = 0;
  if (query.length === 0) {
    bodyFetch.limit = 40;
    bodyFetch.search = '';
    dispatch({ type: BrandsTypes.SET_THERE_ARE_MORE_BRANDS, payload: true });
    dispatch({ type: BrandsTypes.RESET_BODY_SEARCH });
    return await getPaginationBrandsAction({ dispatch, bodyFetch, token, translate });
  }
  if (query.length >= 2) {
    bodyFetch.limit = 200;
    bodyFetch.search = query;
    return await getPaginationBrandsAction({ dispatch, bodyFetch, token, translate });
  }
  dispatch({ type: BrandsTypes.SET_BODY_SEARCH, payload: query });
  return true;
}
